import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserNotificationValueObject} from "../../../data/value-object/user/UserNotificationValueObject";
import {UserNotificationSearchOption} from "../../../data/search-option/user/UserNotificationSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {UserNotificationIO} from "../../../io/UserIO";
import {UserNotificationDescription} from "../../../data/description/user/UserNotificationDescription";
import {UserNotificationDescriptor} from "../../../data/descriptor/user/UserNotificationDescriptor";
import ListOption from "../../ListOption";
import {
    UserNotificationSearchOptionDescription
} from "../../../data/description/user/UserNotificationSearchOptionDescription";
import {
    applyUserNotificationSearchOption,
    UserNotificationSearchOptionField
} from "../../search-option-field/user/UserNotificationSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserNotificationValueObject[]>([])
    const option = useStatePair<UserNotificationSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserNotificationIO}
                items={items}
                option={option.value}
                index={index}
                description={UserNotificationDescription}
                descriptor={UserNotificationDescriptor}
                showPost
                onPostClick={() => document.location = '/users/notifications/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/notifications/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserNotificationSearchOptionDescription}
                fields={UserNotificationSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserNotificationSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserNotificationDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}